module.exports = __webpack_public_path__ + "static/media/CustomizationInActive.3740e10c.svg";